import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { PagesComponent } from './pages.component';
import { routeSkeleton } from './pages-menu';


const routes: Routes = [{
  path: '',
  component: PagesComponent,
  children: routeSkeleton,
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {
}
